<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-icon card-header-rose">
						<div class="card-icon">
							<i class="material-icons">edit</i>
						</div>
						<h4 class="card-title">Editar Lead</h4>
					</div>
					<b-form @submit="onSubmit" novalidate="novalidate">
						<div class="card-body">
							<div class="row">
								<div class="col-md-8">
									<div class="form-group bmd-form-group"
									     v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
										<label for="name" class="bmd-label-floating">Nome *</label>
										<input refs="name" v-bind:disabled="checkTypeStatus()" type="text" class="form-control" v-model="form.name" />
										<label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
									</div>

									<div class="form-group bmd-form-group"
									     v-bind:class="{'is-filled': form.phone != '', 'has-danger' : validation.phone != '' }">
										<label for="phone" class="bmd-label-floating">Telefone *</label>
										<the-mask v-bind:disabled="checkTypeStatus()" refs="phone" type="text" class="form-control" v-model="form.phone" :mask="['(##) #####-####', '(##) ####-#####']"></the-mask>
										<label v-if="validation.phone != ''" id="phone-error" class="error" for="phone">{{ validation.phone }}</label>
									</div>

									<div class="form-group bmd-form-group"
									     v-bind:class="{'is-filled': form.email != '', 'has-danger' : validation.email != '' }">
										<label for="email" class="bmd-label-floating">E-mail</label>
										<input v-bind:disabled="checkTypeStatus()" refs="email" type="text" class="form-control" v-model="form.email" />
										<label v-if="validation.email != ''" id="email-error" class="error" for="email">{{ validation.email }}</label>
									</div>

									<div class="form-group bmd-form-group"
									     v-bind:class="{'is-filled': form.street != '', 'has-danger' : validation.street != '' }">
										<label for="street" class="bmd-label-floating">Rua</label>
										<input v-bind:disabled="checkTypeStatus()" refs="street" type="text" class="form-control" v-model="form.street" />
										<label v-if="validation.street != ''" id="street-error" class="error" for="street">{{ validation.street }}</label>
									</div>

									<div class="row">
										<div class="col-md-4">
											<div class="form-group bmd-form-group"
											     v-bind:class="{'is-filled': form.neighborhood != '', 'has-danger' : validation.neighborhood != '' }">
												<label for="neighborhood" class="bmd-label-floating">Bairro</label>
												<input v-bind:disabled="checkTypeStatus()" refs="neighborhood" type="text" class="form-control" v-model="form.neighborhood" />
												<label v-if="validation.neighborhood != ''" id="neighborhood-error" class="error" for="neighborhood">{{ validation.neighborhood }}</label>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group bmd-form-group"
											     v-bind:class="{'is-filled': form.city != '', 'has-danger' : validation.city != '' }">
												<label for="city" class="bmd-label-floating">Cidade</label>
												<input v-bind:disabled="checkTypeStatus()" refs="city" type="text" class="form-control" v-model="form.city" />
												<label v-if="validation.city != ''" id="city-error" class="error" for="city">{{ validation.city }}</label>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group bmd-form-group"
											     v-bind:class="{'is-filled': form.state != '', 'has-danger' : validation.state != '' }">
												<label for="state" class="bmd-label-floating">Estado</label>
												<input v-bind:disabled="checkTypeStatus()" refs="state" type="text" class="form-control" v-model="form.state" />
												<label v-if="validation.state != ''" id="state-error" class="error" for="state">{{ validation.state }}</label>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group"
									     v-bind:class="{'is-filled': form.revision != '', 'has-danger' : validation.revision != '' }">
										<label for="date">Data da Próxima Visita</label>
										<br/>
										<label for="date">{{form.date}}</label>
									</div>

									<div class="form-group"
									     v-bind:class="{'is-filled': form.lead_status_id != '', 'has-danger' : validation.lead_status_id != '' }">
										<label for="name" class="bmd-label-floating">Status *</label>
									</div>
									<div class="form-group"
										
									     v-bind:class="{'is-filled': form.lead_status_id != '', 'has-danger' : validation.lead_status_id != '' }">
										<select v-bind:disabled="checkTypeStatus()" style="padding-left: 5px;border-top: 1px solid #cccccc;border-left: 1px solid #cccccc;border-right: 1px solid #cccccc" placeholder="Status" v-model="form.lead_status_id" class="form-control">
											<option v-for="option in status" v-bind:value="option.id">
												{{ option.status }}
											</option>
										</select>
										<br clear="all">
									</div>

									<div class="form-group"
									     v-bind:class="{'is-filled': form.lead_status_id != '', 'has-danger' : validation.lead_status_id != '' }">
										<label v-if="validation.lead_status_id != ''" id="status-error" class="error" for="status">{{ validation.lead_status_id }}</label>
									</div>
									<div class="form-group"
									     v-bind:class="{'is-filled': form.user_id != '', 'has-danger' : validation.user_id != '' }">
										<label for="responsavel" class="bmd-label-floating">Responsável</label>
									</div>
									<div class="form-group"
									     v-bind:class="{'is-filled': form.user_id != '', 'has-danger' : validation.user_id != '' }">
										 <br/>
										 <label>{{form.user ? form.user.name : ''}}</label>
										<br clear="all">
									</div>
									<div class="form-group"
									     v-bind:class="{'is-filled': form.user_id != '', 'has-danger' : validation.user_id != '' }">
										<label v-if="validation.user_id != ''" id="responsavel-error" class="error" for="responsible">{{ validation.user_id }}</label>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-8">
									<div class="form-group bmd-form-group"
									     v-bind:class="{'is-filled': form.details != '', 'has-danger' : validation.details != '' }">
										<label for="details" class="bmd-label-floating">Detalhes</label>
										<textarea v-bind:disabled="checkTypeStatus()" refs="details" type="text" class="form-control" v-model="form.details"></textarea>
										<label v-if="validation.details != ''" id="details-error" class="error" for="details">{{ validation.details }}</label>
									</div>
								</div>
                                                            <div class="col-md-4">
                                                                <div class="form-group bmd-form-group is-filled">
                                                                    <label for="value" class="bmd-label-floating">Valor de Interesse *</label>
                                                                    <money v-model="form.value" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                                    <label v-if="validation.value != ''" id="value-error" class="error" for="value">{{ validation.value }}</label>
                                                                </div>
                                                            </div>
							</div>
						</div>
						<div class="card-footer">
							<form-buttons 
							:toBackAuto="true"
							:disabledSave="checkTypeStatus()">

								<a :href="'https://wa.me/55' + form.phone" title="Chamar no Whatsapp" alt="Chamar no Whatsapp" target="_blank" class="btn btn-success btn-whatsapp">
									<img src="../../assets/whatsapp.png" />
								</a>
							</form-buttons>
						</div>
					</b-form>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h4 class="card-title">Comentários</h4>
					</div>
					<div class="card-body p-0">
						<table v-if="form.leads_comments" class="table table-striped table-sm text-center">
							<thead>
							<tr>
								<th>Data</th>
								<th>Usuário</th>
								<th>Comentário</th>
							</tr>
							</thead>
							<tr v-for="item in form.leads_comments">
								<td>{{moment(item.created_at).format('DD/MM/YYYY HH:mm')}}</td>
								<td>{{item.user.name}}</td>
								<td>{{item.commentary}}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h4 class="card-title">Adicionar Comentário</h4>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col-md-8">
								<div class="form-group bmd-form-group">
									<label for="new_date">Comentário:</label>
									<input refs="new_date" v-bind:disabled="checkTypeStatus()" type="text" class="form-control"  v-model="new_comment"/>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group bmd-form-group">
									<label for="new_date">Data da Próxima Revisão:</label>
								<date-picker refs="new_date" v-bind:disabled="checkTypeStatus()" style="width:95%" v-model="new_date" title="Data da Próxima Revisão" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                                           
								</div>
							</div>
						</div>
					</div>
					<div class="card-footer">
						<div role="group" class="btn-group"><button v-bind:disabled="checkTypeStatus()" type="button" @click="addComment" class="btn btn-rose"><span class="btn-label"><i class="material-icons">add</i></span>
							Adicionar Comentário
						</button><!----></div>
					</div>
				</div>
			</div>
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h4 class="card-title">Histórico</h4>
					</div>
					<div class="card-body p-0">
						<table v-if="form.leads_histories" class="table table-striped table-sm text-center">
							<thead>
							<tr>
								<th>Data</th>
								<th>Usuário</th>
								<th>Atividade</th>
							</tr>
							</thead>
							<tr v-for="item in form.leads_histories">
								<td>{{moment(item.created_at).format('DD/MM/YYYY HH:mm')}}</td>
								<td>{{item.user.name}}</td>
								<td><small>{{item.history}}</small></td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
    import Vue from "vue";

    export default {
        computed: {
            status: {
                set(_items) {
                    this.$store.commit("lead_status/setList", _items);
                },
                get() {
                    return this.$store.state.lead_status.itens;
                }
            },
            responsibles: {
                set(_items) {
                    this.$store.commit("users/setList", _items);
                },
                get() {
                    return this.$store.state.users.itens;
                }
            }
        },
        data() {
            return {
                new_comment: '',
                new_date: '',
				moment: Vue.moment,
				lead_status_id_origin: '',
                form: {
                    name: '',
                    lead_status_id: '',
                    phone: '',
                    email: '',
                    street: '',
                    neighborhood: '',
                    city: '',
                    state: '',
                    details: '',
                    user_id: null,
                    leads_histories: [],
                    value: ''
                },
                file_form: {
                    file: null,
                },
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                validation: {
                    name: '',
                    lead_status_id: '',
                    phone: '',
                    email: '',
                    street: '',
                    neighborhood: '',
                    city: '',
                    state: '',
                    details: '',
                    user_id: '',
                    leads_histories: [],
                    value: ''
                },
                imports: []
            };
        },
        created: async function() {
			console.log('Router ', this.$router)
            this.new_comment = '';
            this.new_date = '';
            this.status = [];
            this.imports = [];
            this.responsibles = [];
            this.import = [];
            await this.getData();
            this.getDataStatus();
            this.getUsers();
        },
        methods: {
			redirectRoute() {
				this.$router.back();
				console.log('route ', this.$route, ' ', this)
			},
			checkTypeStatus() {
				const checked = this.status.filter((ele) => {
					return ((ele.status == 'Não tem Interesse' || ele.status == 'Vendido') && this.lead_status_id_origin == ele.id)
				})
				return checked.length > 0;
			},
            async getDataStatus() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('lead_status/all');

                response.then(function (x) {
                    self.$root.$emit('onLoading');
                    self.status = x.filter((ele) => {
						console.log("self.form.lead_status_id ", self.form.lead_status_id, ' ', ele)
						if (ele.id == self.form.lead_status_id) {
							return true
						} 
						return (ele.status !== 'Vendido')
					});
                    self.getData();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.getData();
                });
            },
            async getData() {
                var self = this;
                const response = self.$store.dispatch("lead/get", this.$route.params.id);

                await response.then(async function(y) {
					self.form = await y;
					self.lead_status_id_origin = y.lead_status_id
					self.new_date = Vue.moment().add(self.form.lead_status.term, 'days').toDate();
					self.form.date = Vue.moment(self.form.date).format('DD/MM/YYYY');
					console.log('form >>> ', self.form)
                });

                response.catch(function() {
                });
            },
            async getUsers() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('users/all');

                response.then(function (x) {
                    self.responsibles = x;
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            addComment(_ev) {

                var self = this;
                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('lead_comments/add', {
                    lead_id: self.$route.params.id,
	                commentary: self.new_comment,
	                new_date: Vue.moment(self.new_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
                });

                response.then(function () {
                    self.$root.$emit('onLoading');
                    self.getData();
                    self.$notify.success("Lead atualizado com sucesso!");
                });

                response.catch(function (err) {
                    self.$root.$emit('onLoading');
                    if (err.status === 422) {
                        if (err.data.errors.name !== undefined) {
                            self.validation.name = err.data.errors.name[0];
                        }
                    }
                });

                _ev.preventDefault();
            },
            onSubmit(_ev) {
                var self = this;
                var valid = true;
                self.validation.name = '';
                self.validation.phone = '';
                self.validation.lead_status_id = '';
                self.validation.value = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.phone == '') {
                    self.validation.phone = 'Campo obrigatório!';
                    valid = false;
                }
                if (self.form.lead_status_id == '') {
                    self.validation.lead_status_id = 'Campo obrigatório!';
                    valid = false;
                }
                if (self.form.value == '') {
                    self.validation.value = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit('onLoading');
					 this.form.date = Vue.moment(this.form.date, 'DD/MM/YYYY').format("YYYY-MM-DD")
                    const response = self.$store.dispatch('lead/edit', this.form);

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.getData();
                        self.$notify.success("Lead atualizado com sucesso!");
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 422) {
                            if (err.data.errors.name !== undefined) {
                                self.validation.name = err.data.errors.name[0];
                            }
                        }
                    });
                }

                _ev.preventDefault();
            },
        }
    };
</script>

<style scoped>
	.btn-whatsapp img {
        width: 20px;
        height: 20px;
    }
</style>
